import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import _ from 'lodash';
import config from '../../config';
import '../../resources/css/bootstrapHelper.css'; 

// TODO
// Error handle
// loading spinner
// possibly remove tools

class RegistrationTotalCardV2 extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        loading:true,
        total:0
      };
    }

    formatNumber(value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    async loadOut(){
        let formData;
        let qResp;
        let qData;
        
        let qWhere="1=1";
        let url=config.apiv2.registrationStage;
        let total=0;

        formData=new FormData();
        formData.append("where",qWhere);
        formData.append("outFields","*");
        formData.append("returnGeometry","false");
        formData.append("orderByFields","Priority_Category");
        formData.append("returnDistinctValues","false");
        formData.append("f","json");

        try{
            qResp = await fetch(url+"/query",{method:"post",body:formData});
            qData = await qResp.json();
        }catch(err){
            console.log(err);
        }

        if(_.get(qData,"features.length",0)>0){
            _.forEach(qData.features,function(value,key){
                total+=value.attributes.total;
            });
            this.setState({
                loading:false,
                total:this.formatNumber(total),
                error:false,
            });
        }else{
            // error handle
            this.setState({
                loading:false,
                error:true
            });
        }
    }

    componentDidMount(){
        this.loadOut();
    }

    render() {
        if(this.state.loading===true){
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <div id="loader" style={{textAlign:"center"}}>
                        <Row>
                            <Col>
                                <Spinner animation="border" variant="primary" />
                            </Col>
                        </Row>
                    </div>
                </Container>
            );

        }else if(this.state.loading===false && this.state.error===true){
            //show error
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <Alert></Alert>
                </Container>
            );
        }else{
            return (
                <Card className="text-center h-100">
                    <Card.Header style={{backgroundColor:"#b63a3a",color:"#FFFFFF"}}>Total Pre-Registrations</Card.Header>
                    <Card.Body className="align-items-center d-flex justify-content-center">
                        <Card.Title as="h2">{this.state.total}</Card.Title>
                    </Card.Body>
                    <Card.Footer>
                        <small className="text-muted">1/15/21 to Current</small>
                    </Card.Footer>
                </Card>
            );
        }
    }
}

export default RegistrationTotalCardV2;